<template>
  <div>
    <el-popover  placement="top-start" trigger="click" width="500" title="HEX组件">
      <div>
        <input-code v-model="value.value" is-custom placeholder="请输入16进制字符串"></input-code> 
      </div>
      <el-tag slot="reference" type="info" :style="{color:'#FFF'}" :color="value.color" closable @close="$emit('delete',value)">{{ value.value||value.name }}</el-tag>
    </el-popover>
  </div>
</template>
<script>
  import inputCode from '@/components/input-code16'
  export default {
    props: ['value'],
    components:{inputCode},
    data () {
      return {
      }
    }
  }
</script>
<style lang="scss" scoped>
.el-tag{
  cursor: pointer;
}
</style>